// @owners { team: patient-health }
import { BORDERS } from '@alto/design-library-tokens';
// eslint-disable-next-line @alto/no-pocky-import
import { FlexRow, H3, Link, Text, palette, spacing } from '@alto/pocky';
import React from 'react';
import styled from 'styled-components';

type DefaultProps = {
  readonly isCashPayOnly?: boolean;
};

type Props = DefaultProps;
const ProcessingInsuranceContainer = styled(FlexRow)`
  padding: ${spacing.smSpacing};
  border: ${BORDERS.SIZE}px solid ${palette.grey2};
  background-color: ${palette.altoColorsW};
`;

export default class ProcessingInsurance extends React.PureComponent<Props> {
  static defaultProps: DefaultProps = {
    isCashPayOnly: false,
  };

  render() {
    const { isCashPayOnly } = this.props;
    return (
      <ProcessingInsuranceContainer spacing={spacing.smSpacing}>
        {isCashPayOnly ? (
          <Text>
            We’re working to find the best price for your medication. We’ll follow up soon with the price so you can
            schedule this medication for delivery.
          </Text>
        ) : (
          <>
            <H3>Processing your insurance...</H3>
            <Text>
              We’re processing your <Link href="/me">insurance information</Link> to find the best price for your
              medication. We’ll follow up soon with the price so you can schedule this medication for delivery.
            </Text>
          </>
        )}
      </ProcessingInsuranceContainer>
    );
  }
}
